interface PageBannerProps {
    imageURL?: string
    text: string
}
export const PageBanner = ({ imageURL, text }: PageBannerProps) => {
    return <div className="relative w-full">
        <img src={imageURL} className="absolute z-0 inset-0 h-full w-full object-cover object-right" />
        <div className="relative z-[1] flex items-center justify-center font-bold text-4xl md:text-7xl py-10 md:py-20 bg-gradient-to-t from-black to-transparent">{text}</div>
    </div>
}